import { render, staticRenderFns } from "./TabelaContatos.vue?vue&type=template&id=339a653a&scoped=true"
import script from "./TabelaContatos.vue?vue&type=script&lang=js"
export * from "./TabelaContatos.vue?vue&type=script&lang=js"
import style0 from "./TabelaContatos.vue?vue&type=style&index=0&id=339a653a&prod&lang=scss&scoped=true"
import style1 from "./TabelaContatos.vue?vue&type=style&index=1&id=339a653a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339a653a",
  null
  
)

export default component.exports